/* Color Theme Swatches in Hex */
export default [
        "#CCA991",
        "#A6855D",
        "#7B8798",
        "#7A69FF",
        "red"
]                           

